import React, { useEffect, useState } from 'react';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function CuadroReacciones(props) {
    const {item,regional}=props;
    const [reaccionNoticia,setReaccionNoticia]=useState({});
    const [actualizaR,setActualizaR]=useState(0);

    const info = JSON.parse(localStorage.getItem('info'));
    const esInvitado = !info || info.ID_EMPLEADO === -1;
    const claseBloqueo = esInvitado ? 'opacity-50 pe-none' : '';

    const reaccionar = (item, tipo) => {

        console.log('esInvitado:', esInvitado);

        if (esInvitado) {
            MsgUtils.msgError("Debes iniciar sesión para reaccionar");
            return;
        }

        fetch(`${server}/redSocial/reaccionarNoticia`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,
                tipo,
                idEmpleado: info.ID_EMPLEADO,
                idNoticia: item.ID_NOTICIA
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.ok) {
                setReaccionNoticia(data.ok);
                setActualizaR(actualizaR + 1);
            } else {
                MsgUtils.msgError(data.error);
            }
        })
        .catch(err => console.log(err));
    };

    useEffect(()=>{
        setReaccionNoticia(item);
    },[])
    return (
        <div className='btn-group'>
            <a
            className={`btn btn-sm m-0 p-0 mx-2 text-center
            ${reaccionNoticia.REACCION === 'L' ? 'text-warning' : 'text-light'}
            ${claseBloqueo}`}
            onClick={() => reaccionar(item, 'L')}
            title={esInvitado ? 'Inicia sesión para reaccionar' : ''}
            >
                <div className='container-fluid'>
                    <i className="fa-regular fa-thumbs-up fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.GUSTA}</span>
                </div>
            </a>

            <a
            className={`btn btn-sm m-0 p-0 mx-2 text-center 
            ${reaccionNoticia.REACCION === 'F' ? 'text-warning' : 'text-light'}
            ${claseBloqueo}`}
            onClick={() => reaccionar(item, 'F')}
            title={esInvitado ? 'Inicia sesión para reaccionar' : ''}
            >
                <div className='container-fluid'>
                    <i className="fa-regular fa-thumbs-down fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.NOGUSTA}</span>
                </div>
            </a>

            <a
            className={`btn btn-sm m-0 p-0 mx-2 text-center 
            ${reaccionNoticia.REACCION === 'E' ? 'text-warning' : 'text-light'}
            ${claseBloqueo}`}
            onClick={() => reaccionar(item, 'E')}
            title={esInvitado ? 'Inicia sesión para reaccionar' : ''}
            >
                <div className='container-fluid'>
                    <i className="fa-solid fa-heart fa-xl"></i>
                    <span className="badge bg-secondary">{reaccionNoticia.ENCANTA}</span>
                </div>
            </a>

            <a
            className={`btn btn-sm m-0 p-0 mx-2 
            ${reaccionNoticia.SYNC !== null ? 'text-warning' : 'text-light'}
            ${claseBloqueo}`}
            onClick={() => reaccionar(item, 'M')}
            title={esInvitado ? 'Inicia sesión para guardar en favoritos' : ''}
            >
                <i className="fa-solid fa-star fa-xl"></i>
            </a>
        </div>

    )
}

export default CuadroReacciones
